<template>
    <div>

        <div class="form-row">
            <div class="col col-12 col-md-3">
                <az-input
                    :sizing="sizing"
                    type="date"
                    label="Data do Atendimento"
                    required
                    :validate="validate"
                    :edicao="!dados"
                    v-model="referencia">
                    <template v-slot:buttonposb v-if="dados">
                        <div class="input-group-append">
                            <span class="input-group-text" v-if="dados.id_atendimento" title="Atendimento">
                                #{{ dados.id_atendimento }}
                            </span>
                            <span class="input-group-text" v-else title="Marcação">
                                M{{ dados.id_marcacao }}
                            </span>
                        </div>
                    </template>
                </az-input>
            </div>
            <div class="col col-12 col-md-9">
                <az-input 
                    :sizing="sizing"
                    placeholder="Selecione o Paciente..."
                    label="Paciente"
                    type="autocomplete" 
                    optionsMode="aql"
                    optionsName="estoque.ident_paciente_consumo"
                    :optionsParm="{ 
                        data: this.referencia,
                        unidade: this.unidade, 
                        devolucao: this.devolucao ? 1 : 0
                    }"
                    service="estoque.ident_paciente_consumo"
                    required
                    :validate="validate"
                    :edicao="edicao"
                    v-model="dados"
                    ref="info_marcacao" />
            </div>
        </div>
    </div>
</template>

<script>
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() { 
        return { 
            search: "",
            dados: "", 
            referencia: this.$util.hoje(), 
        };
    },

    props: [ 
        'unidade',
        'value',
        'validate', 
        'edicao',
        'sizing', 
        'devolucao', 
    ],

    components: { 
        AzInput,
    },

    watch: { 
        dados: function () { 
            this.$emit('input', this.dados ? this.dados.id_marcacao : null);
        },
    },

    methods: { 
        get_marcacao () { 
            return this.dados ? this.dados : null;
        },
        
        get_procs () { 
            return this.dados ? this.dados.procs : [];
        },

        buscar() { 
            this.$util.load(this, { 
                service: 'estoque', 
                func: 'ident_paciente_consumo',
                parms: { 
                    data: this.$util.hoje(),
                    unidade: this.unidade, 
                    search: this.search,
                    devolucao: this.devolucao ? 1 : 0,
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
        }
    }
}
</script>